import React, { useEffect, useState } from 'react';
import logger from "utils/logger";
import { useDispatch, useSelector } from "react-redux";
import useLoginInfo from "hooks/useLoginInfo";
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import validate from "utils/validate";
import { ButtonLoader, Input } from "components/__new/common/form";
import * as auth from "store/auth/user/action";
import { ReactComponent as EyeMasked } from "assets/images/icons/project-icons/eye-masked.svg"
import { ReactComponent as EyeRevealed } from "assets/images/icons/project-icons/eye-revealed.svg"


export const ResetPassword = () => {
    const history = useHistory();
    const {userInfo} = useLoginInfo();
    const dispatch = useDispatch();
    const { forgotPasswordLoading, forgotPasswordForm, resetPasswordLoading, resetPassword } = useSelector((s) => s.auth.user);

    const [form, setForm] = useState({
        email: "",
        pin: "",
        password: "",
        confirmPassword: "",
    })
    
    const [pwdShown, setPwdShown] = useState(false);
    const [confirmPwdShown, setConfirmPwdShown] = useState(false);


    const submitForm = async (e) => {
        e.preventDefault();
        const errors = validate(form);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            dispatch(auth.resetPassword(form));
        }
    }

    const resendMail = () => {
        dispatch(auth.forgotPassword({email: form.email}));
    }
    
    const togglePwdShown = () => {
        setPwdShown(!pwdShown)
    }
    
    const toggleConfirmPwdShown = () => {
        setConfirmPwdShown(!confirmPwdShown)
    }

    useEffect(() => {
        const currentForm = {...form, ...forgotPasswordForm};
        setForm(currentForm);

        if (resetPassword === true){
            logger("employer-reset-password", userInfo);
            history.push("/reset-password/success");
            dispatch(auth.resetResetPassword());
        }
        // eslint-disable-next-line
    }, [resetPassword])


    return (
        <>

            <DynamicHeadTag
                headerText="Reset Password"
            />

            <div className="p-8">
                <div>
                    
                    <div className="text-center">
                        <div className="text-2xl font-semibold">
                            Create a new password
                        </div>
                    </div>

                    <div>
                        <div>

                            <div className="mt-10 w-full max-w-md mx-auto md:mx-0 lg:w-96">

                                <div className="note mb-4 text-center hidden">
                                    A password reset pin has been sent to your email address
                                </div>
                                
                                <form onSubmit={submitForm}>
                                    <Input type="email" label="Business Email" placeholder="business@mail.com" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} disabled />
                                    <Input type="number" label="Reset PIN" placeholder="" value={form.pin} onChange={(e) => setForm({...form, pin: e.target.value})} />
                                    
                                    <div className="relative">
                                        <Input
                                            type={pwdShown ? "text" : "password"} 
                                            label="Password"
                                            autoComplete="off"
                                            value={form.password}
                                            placeholder="XXXXXXXXXX"
                                            onChange={(e) => setForm({...form, password: e.target.value})}
                                        />
                                        
                                        <div className="absolute top-8 right-2">
                                            {pwdShown ? <EyeRevealed onClick={togglePwdShown} /> :  <EyeMasked onClick={togglePwdShown} />}
                                        </div>
                                    </div>
                                    
                                    <div className="relative">
                                        <Input
                                            autoComplete="off"
                                            label="Conrifm Password"
                                            placeholder="XXXXXXXXXX"
                                            value={form.confirmPassword}
                                            type={confirmPwdShown ? "text" : "password"} 
                                            onChange={(e) => setForm({...form, confirmPassword: e.target.value})}
                                        />
                                        
                                        <div className="absolute top-8 right-2">
                                            {confirmPwdShown ? <EyeRevealed onClick={toggleConfirmPwdShown} /> :  <EyeMasked onClick={toggleConfirmPwdShown} />}
                                        </div>
                                    </div>                                    

                                    <ButtonLoader
                                        type="submit" loading={resetPasswordLoading}
                                        disabled={form?.pin?.length < 4 || form.password === "" || (form?.password !== form?.confirmPassword)} 
                                        className="btn btn-lg btn-block btn-ep-primary mt-8 disabled:!bg-[#E2E8F0] disabled:cursor-not-allowed transition-colors duration-300">
                                        Reset Password
                                    </ButtonLoader>
                                    
                                    <div className="mt-5 text-sm text-gray-400 text-center">
                                        Didn't get mail? &nbsp;
                                        <ButtonLoader type='button' onClick={resendMail} loading={forgotPasswordLoading} className="font-semibold text-ep-primary hover:underline whitespace-nowrap">Resend Mail</ButtonLoader>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            
        </>
    )
}
 

export default ResetPassword;